// https://github.com/lydiagoulding/react-nmi-collectjs/blob/master/src/hooks/useCollect.js

import React, { useContext, useEffect } from 'react'
import {
  // useCollect,
  CardNumberInput,
  CardExpirationInput,
  CardCVVInput,
  /// /
  CheckNameInput,
  CheckAccountInput,
  CheckRoutingNumberInput,
  /// /
  ValidationContainer,
  ValidationContainerFields,
} from '@lydiagoulding/react-nmi-collectjs'
import CollectJSContext from '@lydiagoulding/react-nmi-collectjs/lib/esm/contexts/CollectJSContext'

import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import FormHelperText from '@mui/joy/FormHelperText'
import Tabs from '@mui/joy/Tabs'
import TabList from '@mui/joy/TabList'
import Tab from '@mui/joy/Tab'
import TabPanel from '@mui/joy/TabPanel'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import AppleIcon from '@mui/icons-material/Apple'
import AndroidIcon from '@mui/icons-material/Android'
import Typography from '@mui/joy/Typography'

export function useCollect ({
  onTimeout,
  onResponse,
  // onFieldInvalid,
}) {
  const { unsetErrors, addError, collectJS } = useContext(CollectJSContext)

  // const reset = useCallback(() => {
  //   collect.retokenize()
  // }, [collect])

  useEffect(() => {
    // console.log('useCollect useEffect', { collectJS })
    if (!collectJS) { return }
    collectJS.configure({
      // https://secure.networkmerchants.com/merchants/resources/integration/integration_portal.php?tid=a551cb23c861620f7750474e8d5d3ed8&rand=30756
      fields: {
        ccnumber: { placeholder: '0000 0000 0000 0000' },
        ccexp: { placeholder: '00 / 00' },
        cvv: { placeholder: '***' },
        checkaccount: { placeholder: '000000000000' },
        checkaba: { placeholder: '000000000' },
        checkname: { placeholder: 'John Doe' },
      },
      customCss: {
        'border-radius': '7px',
        // "background-color": "#a0a0ff",
        // "color": "#0000ff",
      },
      variant: 'inline',
      styleSniffer: true, // https://github.com/gateway-services/collectjs-react-demo/blob/master/src/InlineCartPage/InlineCartPage.js
      timeoutDuration: 10000,
      timeoutCallback: onTimeout,
      callback: onResponse,
      validationCallback: function (fieldName, valid, message) {
        if (valid) {
          unsetErrors(fieldName)
        } else {
          // onFieldInvalid(fieldName)
          unsetErrors(fieldName)
          addError(fieldName, message)
        }
      },
    })
  }, [collectJS])

  // return [collectJS, reset]
  return collectJS
}

function FormInput ({ validationFilter, label, children }) {
  return (
    <ValidationContainer validationFields={[validationFilter]}>
      {({ isValid, errors }) => (
        <FormControl error={!isValid}>
          <FormLabel>{label}</FormLabel>
          {children}
          {errors.map((error, index) => (
            <FormHelperText key={index}><InfoOutlined />{error.message}</FormHelperText>
          ))}
        </FormControl>
      )}
    </ValidationContainer>
  )
}

function NmiCreditCardInputs ({ onTimeout, onResponse }) {
  // const collectJS = useCollect({
  //   onTimeout,
  //   onResponse,
  // })

  return (
    <>
      <FormInput validationFilter={ValidationContainerFields.ccNumber} label='Number'><CardNumberInput /></FormInput>
      <FormInput validationFilter={ValidationContainerFields.ccExp} label='Expiration'><CardExpirationInput /></FormInput>
      <FormInput validationFilter={ValidationContainerFields.cvv} label='CVV'><CardCVVInput /></FormInput>
    </>
  )
}

// https://secure.networkmerchants.com/gw/merchants/resources/integration/integration_portal.php#testing_information
// Test Data
// Transactions can be submitted using the following information:
// Visa: 4111111111111111
// MasterCard: 5431111111111111
// Discover: 6011000991300009
// American Express: 341111111111111
// Diner's Club: 30205252489926
// JCB: 3541963594572595
// Maestro: 6799990100000000019
// Credit Card Expiration: 10/25
// account (ACH): 24413815
// routing (ACH): 490000018
//
// Triggering Errors in Test Mode
//
// To cause a declined message, pass an amount less than 1.00.
// To trigger a fatal error message, pass an invalid card number.
// To simulate an AVS match, pass 888 in the address1 field, 77777 for zip.
// To simulate a CVV match, pass 999 in the cvv field.
function NmiAchInputs ({ onTimeout, onResponse }) {
  // const collectJS = useCollect({
  //   onTimeout,
  //   onResponse,
  // })
  return (
    <>
      <FormInput validationFilter={ValidationContainerFields.checkName} label='Account holder name'><CheckNameInput /></FormInput>
      <FormInput validationFilter={ValidationContainerFields.checkAccount} label='Account number'><CheckAccountInput /></FormInput>
      <FormInput validationFilter={ValidationContainerFields.checkAba} label='Routing number / Aba'><CheckRoutingNumberInput /></FormInput>
    </>
  )
}

const creditCardsDisabled = window.appRailsEnv === 'production'
// const creditCardsDisabled = true

export function NmiTabs ({ onTimeout, onResponse }) {
  // const CollectJSContextState = React.useContext(CollectJSContext)
  // console.log(CollectJSContextState)

  // const [tab, setTab] = React.useState('card')
  // console.log('NmiTabs render', tab)

  // // console.log('NmiAchInputs')

  // const handleTabChange = useCallback((_event, value) => {
  //   console.log('handleTabChange', _event, value)
  //   setTab(value)
  // })

  // useEffect(() => {
  //   console.log('useEffect', collectJS, tab)
  //   if (collectJS) {
  //     collectJS.configure()
  //   }
  // }, [ collectJS, tab ])

  // String ("cc" or "ck")
  // return (<div>asdf</div>)

  return (
    <>
      {creditCardsDisabled && (
        <>
          <Typography color='danger' level='body-sm'>Credit card payments are disabled because of blockings.<br />For now, please donate using eCheck / ACH.</Typography>
        </>
      )}
      <Tabs aria-label='Nmi form' defaultValue={creditCardsDisabled ? 'check' : 'card'}>
        <TabList>
          <Tab value='card' disabled={creditCardsDisabled}><CreditCardIcon />Credit card</Tab>
          <Tab value='check'><AccountBalanceIcon />ACH</Tab>
          <Tab value='apple_pay' disabled><AppleIcon />Apple pay</Tab>
          <Tab value='google_pay' disabled><AndroidIcon />Google pay</Tab>
        </TabList>
        <TabPanel disabled={creditCardsDisabled} value='card' keepMounted={false}>
          <NmiCreditCardInputs onTimeout={onTimeout} onResponse={onResponse} />
        </TabPanel>
        <TabPanel value='check' keepMounted={false}>
          <NmiAchInputs onTimeout={onTimeout} onResponse={onResponse} />
        </TabPanel>
        <TabPanel disabled value='apple_pay' />
        <TabPanel disabled value='google_pay' />
      </Tabs>
    </>
  )
}
